import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, c = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), n = /* @__PURE__ */ t("path", {
  fill: "#D80027",
  d: "M20 0C13.457 0 7.648 3.142 4 8h32c-3.648-4.858-9.457-8-16-8Zm0 40c6.543 0 12.352-3.142 16-8H4c3.648 4.858 9.457 8 16 8ZM0 20c0 1.37.138 2.708.4 4h39.2c.262-1.292.4-2.63.4-4s-.138-2.708-.4-4H.4c-.262 1.292-.4 2.63-.4 4Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#0052B4",
  d: "M5.858 5.858c-7.81 7.81-7.81 20.474 0 28.284L20 20 5.858 5.858Z"
}, null, -1), h = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "m8.095 14.783 1.294 3.985h4.192l-3.39 2.464 1.294 3.985-3.39-2.463-3.391 2.463 1.295-3.985-3.39-2.464h4.19l1.296-3.985Z"
}, null, -1), i = [
  c,
  n,
  s,
  h
];
function d(_, r) {
  return e(), l("svg", o, [...i]);
}
const p = { render: d };
export {
  p as default,
  d as render
};
